import {createSlice} from '@reduxjs/toolkit';

export type BlockingCallCountState = number;
const initialState: BlockingCallCountState = 0;

export const blockingCallCountSlice = createSlice({
  name: '@@eskso/httpWrapper/blockingCallCount',
  initialState,
  reducers: {
    reset: () => initialState,
    increment: (state) => state + 1,
    decrement: (state) => Math.max(state - 1, 0),
  },
});
